<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import isPlus from "@/js/isPlus";
// import tabBottom from "/components/tabBottom";
export default {
  name: "App",
  created() {},
  mounted() {
    var me = this;
    this.responsive();
    this.$ba.trackEvent("所有", "点击");
    window.addEventListener("resize", () => {
      this.responsive();
    });
    
    me.getcid()
    // 获取消息列表
    me.getNews()
  },
  sockets: {
    getNews: function(data) {
      if (data.data){
        this.$store.state.news = data.data
      }
      if (data.noRead){
        this.$store.state.badge = data.noRead
      }
      if (isPlus && window.plus && data.noRead) {
        plus.runtime.setBadgeNumber(data.noRead);
      }
    },
  },
  methods: {
    responsive() {
      var width = document.body.offsetWidth;
      document.documentElement.style.fontSize = width / 30 + "%";
      if (width > 900) {
        this.$store.commit("pcMode");
      } else {
        this.$store.commit("mobileMode");
      }
    },
    getNews:function(){
      var type,data
      var me = this
      setTimeout(function(){
        if (me.$store.state.userName) {
          type = 'userName'
          data = me.$store.state.userName
        } else if (me.$store.state.wxAppData){
          type = 'unionid'
          data = me.$store.state.wxAppData
        }
        me.$socket.emit('getNews',{
          type: type,
          data: data
        })
      }, 1000)
    },
    getcid:function(){
      var me = this
      if (isPlus && window.plus) {
        var pinf = plus.push.getClientInfo();  
        var cid = pinf.clientid;
        console.log('cid', cid)
        if (cid) {
          me.$store.state.cid = cid;
        } else {
          setTimeout(function(){
            getcid()
          }, 2000)
        }
      }
    }
  },
  
};
</script>

<style lang="less">
* {
  box-sizing: border-box;
  touch-action: pan-y;
}
.imgItem{
  width: 218px;
}
.editContent .el-input__inner,.info-dropdown .el-input__inner,.info-search .el-input__inner{
  box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 3px rgba(0, 0, 0, 0.12) !important;
  background:#222a36;
  border:1px solid #222a36;
  color:#fff;
}
.webM .el-dialog{
  width: 85%;
}
.editContent .el-dialog{
  background-color: #181e26;

}
.editContent .el-dialog__title,.el-form-item__label{
  color:#fff;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #181e26;
}

#app {
  width: 100%;
  height: 100%;
}

.business {
  min-height: 100vh;
  background-color: #181e26;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  .title {
    position: fixed;
    width: 100%;
    height: 50px;
    left: 0;
    top: 0;
    padding: 5px 5vw;
    background-color: rgba(34, 42, 54, 0.9);
    z-index: 999;
    border-bottom: 1px solid #222a36;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
    .title-logo {
      position: absolute;
      top: 9px;
      width: 45px;
      height: 30px;
      left: 5vw;
      background-image: url(assets/logo.png);
      background-size: 100% 100%;
    }
    .title-right {
      position: absolute;
      top: 0vh;
      width: 80vw;
      right: 5vw;
      .menu {
        width: 70vw;
        display: inline-block;
      }
    }
    .title-text {
      font-size: 3rem;
      text-align: center;
      color: #fff;
    }
    .hoverBd {
      cursor: pointer;
    }
    .hoverBd:hover {
      background-color: #303b4a !important;
      transition: 0.6s;
    }
    .title-user {
      width: 10vw;
      height: 50px;
      display: inline-block;
      float: right;
      .guest {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #fff;
        a {
          color: #fff;
          text-decoration: none;
          line-height: 50px;
        }
      }
      .tc {
        position: relative;
        width: 100%;
        color: #fff;
        height: 50px;
        .news {
          position: absolute;
          top: 14px;
          right: 48px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        .userImg {
          position: absolute;
          top: 9px;
          right: 0;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        .userData {
          display: none;
          opacity: 0;
          position: absolute;
          min-width: 60px;
          top: 50px;
          right: -10vw;
          z-index: 999;
          background-color: #202a37 !important;
          border-color: #202a37 !important;
          box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
            0 8px 10px 1px rgba(0, 0, 0, 0.14),
            0 3px 14px 2px rgba(0, 0, 0, 0.12);
          div {
            width: 10vw;
            height: 40px;
            line-height: 40px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 16px;
          }
          div:nth-child(1) {
            border-bottom: 1px solid #666;
          }
        }
        .userDataOn {
          display: block;
          animation: showUser 0.6s;
          animation-fill-mode: forwards;
        }
      }
    }
    .title-time {
      color: #fff;
      font-size: 2rem;
    }
  }
}
.el-table {
  background-color: #20252f;
  border: 1px solid #444e58;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.el-table td,.el-table th {
  background-color: #20252f;
  color: rgb(235, 232, 232);
}
.el-table th, .el-table tr {
  background-color: #20252f;
  color: rgb(235, 232, 232);
}
.el-table td, .el-table th.is-leaf {
  border: 1px solid #444e58;
}
.el-table th, .el-table tr:hover {
  background-color: #2d313a;
}
.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #2d313a;
}
.el-table tr:hover {
  background-color: #2d313a;
}
.el-table .hover-row:hover {
  background-color: #2d313a;
}
@media screen and (max-width: 420px) {
  .business {
    .title {
      width: 100%;
      .title-text {
        font-size: 20px;
      }
      .title-time {
        font-size: 14px;
      }
    }
  }
}
@media screen and (max-width: 899px) {
  .business .title .title-user .tc .userData div {
    width: 20vw;
  }
}
@keyframes showUser {
  0% {
    opacity: 0;
    right: -10vw;
  }
  100% {
    opacity: 1;
    right: 0vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue